// @flow
import { assign } from 'lodash';
import { connect } from 'react-redux';
import { editFilterAndGetAndStoreGrids } from '../modules/actions';
import Poseidon from '../components/pages/Poseidon';

function mapStateToProps(state: State) {
    return {
        user: state.user
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onEditFilter: (gridId, filterId, filterDefinition, name, clientId) => {
            return dispatch(
                editFilterAndGetAndStoreGrids(filterId, filterDefinition, name, clientId)
            )
                .then(() =>
                    ownProps.history.replace(
                        assign({}, ownProps.location, {
                            pathname: `/grids/${gridId}/${filterId}`
                        })
                    )
                )
                .catch.catch(err => console.error(err));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Poseidon);



// WEBPACK FOOTER //
// ./containers/PoseidonContainer.jsx